import store from "@frameworks/web/redux/store";
import { UPCOMING_EVENTS, UPCOMING_EVENTS_ERROR, UPCOMING_EVENTS_HIDE_ERROR, UPCOMING_EVENTS_START_LOADER, UPCOMING_EVENTS_STOP_LOADER, } from "../interface/IUpcomingEvents";
class UpcomingEventsActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    getUpcomingEvents(data) {
        this.dispatch({
            type: UPCOMING_EVENTS,
            payload: { data },
        });
    }
    setError(payload) {
        this.dispatch({
            type: UPCOMING_EVENTS_ERROR,
            payload: { errorData: payload },
        });
    }
    hideError() {
        this.dispatch({
            type: UPCOMING_EVENTS_HIDE_ERROR,
        });
    }
    startLoader() {
        this.dispatch({
            type: UPCOMING_EVENTS_START_LOADER,
        });
    }
    stopLoader() {
        this.dispatch({
            type: UPCOMING_EVENTS_STOP_LOADER,
        });
    }
}
export default UpcomingEventsActions;
